import { render, staticRenderFns } from "./LanguageSelectComponent.vue?vue&type=template&id=4ea1fca9&scoped=true"
import script from "./LanguageSelectComponent.vue?vue&type=script&lang=js"
export * from "./LanguageSelectComponent.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelectComponent.vue?vue&type=style&index=0&id=4ea1fca9&prod&scoped=true&lang=css"
import style1 from "./LanguageSelectComponent.vue?vue&type=style&index=1&id=4ea1fca9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea1fca9",
  null
  
)

export default component.exports